import styled,{ keyframes } from 'styled-components';
import React, { useMemo , useState, useEffect, useContext } from 'react';
import { useSpring, animated } from 'react-spring';
import axios from 'axios';
import { PredContext } from './sportsc/predContext';
import { PriceContext } from './context';
import { Line } from 'react-chartjs-2';



// Simple rotation animation
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  width: 18px;
  height: 18px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-top: 2px solid #0e141b;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  display: inline-block;
  margin-left: 8px;
  vertical-align: middle;
`;

const StatWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 15px;
`;

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  max-width: 320px;
  padding: 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
`;

const StatButton = styled.button`
  background-color: #0e141b;
  color: white;
  padding: 18px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover { background-color: #1e293b; transform: translateY(-2px); }
  &:active { transform: scale(0.98); }
`;

const CloseButton = styled(StatButton)`
  background-color: #ef4444;
  margin-top: 10px;
  &:hover { background-color: #dc2626; }
`;

const BackBtn = styled.button`
  background: #e2e8f0;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  margin-top: 10px;
`;

// --- EXISTING STYLED COMPONENTS ---

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px 24px;
  top: 0;
  background-color: #f8fafc;
  z-index: 10;
  border-bottom: 2px solid #e2e8f0;

`;

const HeaderCell = styled.div`
  font-weight: 700;
  font-size: 0.75rem;
  color: #475569;
  text-transform: uppercase;
  padding: 10px 0;
  text-align: center;
`;

// Dynamic containers that expand columns when 'Line' is toggled
const ArticleContainer = styled(animated.div)`
  display: grid;
  grid-template-columns: ${props => props.$showLine ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)'};
  gap: 10px; 
  width: 100%;
  height: auto;
  max-height: 60vh;
  overflow-y: auto;
  padding: 16px;
  background-color: #f8fafc;
  border-radius: 8px;
`;

const ActContainer = styled(animated.div)`
  display: grid;
  grid-template-columns: ${props => props.$showLine ? 'repeat(4, 1fr)' : 'repeat(3, 1fr)'};
  gap: 10px; 
  width: 100%;
  height: auto;
  max-height: 60vh;
  overflow-y: auto;
  padding: 16px;
  background-color: #f8fafc;
  border-radius: 8px;
`;

const LineInput = styled.input`
  width: 100%;
  height: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  text-align: center;
  font-size: 0.85rem;
  font-weight: 600;
  color: #0e141b;
  outline: none;
  &:focus {
    border-color: #0e141b;
    box-shadow: 0 0 0 2px rgba(14, 20, 27, 0.1);
  }
`;

const LineToggleBtn = styled.button`
  background: ${props => props.$active ? '#0e141b' : '#e2e8f0'};
  color: ${props => props.$active ? '#ffffff' : '#0e141b'};
  border: none;
  padding: 6px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 700;
  font-size: 0.85rem;
  transition: all 0.2s ease;
`;

const SubmitBtn = styled.button`
  background-color: #16a34a;
  color: white;
  width: 100%;
  padding: 12px;
  margin-top: 12px;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    background-color: #15803d;
  }
`;
const TeamSquare = styled.div`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  aspect-ratio: 1.5 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  color: #0e141b;
  text-align: center;
  padding: 4px;
`;

const FullScreenOverlay = styled(animated.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.98);
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
`;

const SectionTitle = styled.h2`
  color: #0d141c;
  font-size: 1.375rem;
  font-weight: bold;
  padding: 1.25rem 1rem 0.75rem;
`;

const GameAnalysisContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background-color: #f8fafc;
`;

const SubscriptionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: white;
  margin: 0 1rem 0.5rem;
  padding: 0 1rem;
  min-height: 4.5rem;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
`;

const GameAnalysisTitle = styled.p`
  color: #0e141b;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
`;

const IconContainer = styled.div`
  color: #0d141c;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  background-color: #e7edf4;
  width: 3rem;
  height: 3rem;
`;

const GemToggleBtn = styled.button`
  background: #0e141b;
  color: #ffffff;
  border: 1px solid #cbd5e1;
  padding: 6px 14px;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 700;
  text-transform: capitalize;
  font-size: 0.85rem;
  transition: all 0.2s ease;
  &:hover {
    opacity: 0.9;
  }
`;

const FeatureContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  width:30%
  gap: 8px;
  margin: 12px 0;
  padding: 12px;
  background: #f1f5f9;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
`;

const FeatureItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  padding: 6px 8px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
`;

const FeatureLabel = styled.span`
  font-size: 0.7rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
`;

const FeatureValue = styled.span`
  font-size: 0.85rem;
  font-weight: 600;
  color: #0f172a;
`;

const DisplayDiv = styled.div`
display: flex;
  flex-wrap: wrap;       /* Allows elements to wrap to the next row on mobile */
  align-items: center;
  justify-content: space-between; /* Spaces items evenly across rows */
  gap: 10px;            /* Even spacing between all items and rows */
  width: 100%;
  margin: 12px 0;
`

// --- UTILS ---

function shortenValue(val) {
  if (typeof val === 'string' && isNaN(val)) return val;
  return Number(val).toFixed(2);
}

// --- UTILS ---

function formatDateLabel(date) {
  if (!date) return 'Unknown Date';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

function groupTeamsByDate(teams) {
  // Assumes `teams` is already sorted by date (most current first),
  // which orderTeam already guarantees.
  const dateGroups = [];
  const map = {};

  teams.forEach((team) => {
    const date = extractTeamDate(team.team);
    const key = date ? `${date.getMonth()}_${date.getDate()}` : 'unknown';

    if (!map[key]) {
      const group = { key, date, label: formatDateLabel(date), teams: [] };
      map[key] = group;
      dateGroups.push(group);
    }
    map[key].teams.push(team);
  });

  return dateGroups;
}
function extractTeamDate(teamName) {
  // Matches _MM_DD right before .csv (or at the end if no extension)
  const match = String(teamName).match(/(\d{2})_(\d{2})(?:\.csv)?$/);
  if (!match) return null;
  const [, month, day] = match;
  return new Date(2000, parseInt(month, 10) - 1, parseInt(day, 10));
}

function orderTeam(teamData) {
  console.log('team data in order', teamData)
  let count = 0;
  let groups = {};
  for (let i = 0; i < teamData.length; i++) {
    let row = [...teamData[i]];

    // Date-bearing filename is always the last column, regardless of row length
    let teamName = row[row.length - 1];

    const cleanRow = row.slice(0, -1);
    if (!groups[teamName]) {
      groups[teamName] = { team: teamName, data: [cleanRow], id: count };
      count++;
    } else {
      groups[teamName].data.push(cleanRow);
    }
  }

  const result = Object.values(groups).map(group => ({
    ...group,
    data: group.data
      .filter(playerRow => playerRow[3] !== 'Reserves')
      .sort((a, b) => {
        const nameA = a[3] ?? '';
        const nameB = b[3] ?? '';
        return String(nameA).localeCompare(String(nameB));
      })
  }));

  return result.sort((a, b) => {
    const dateA = extractTeamDate(a.team);
    const dateB = extractTeamDate(b.team);
    if (!dateA || !dateB) return 0;
    return dateB - dateA; // most current first
  });
}
// return Object.values(groups).map(group => {
//   return {
//     ...group,
//     data: group.data
//       // 1. Remove the row if the player name (index 6) is 'Reserves'
//       .filter(playerRow => playerRow[4] !== 'Reserves')
//       // 2. Sort by the player name (index 6)
//       .sort((a, b) => a[6].localeCompare(b[6]))
//   };
// });

// --- COMPONENTS ---

function Article({ teamData, statType, handleSelectPlayer, onSaveLines }) {
  const [showLine, setShowLine] = useState(false);
  const { lines , setLines } = useContext(PredContext);

  const teamName = teamData.team; // Current team identifier
  const currentMetricLines = lines[statType] || {};

  const handleLineChange = (player, val) => {
    const parsedVal = val === '' ? '' : Number(val);

    setLines((prev) => {
      const metricMap = { ...(prev[statType] || {}) };

      if (parsedVal === '') {
        delete metricMap[player]; // Remove entry if input is cleared
      } else {
        metricMap[player] = {
          line: parsedVal,
          team: teamName
        };
      }

      return {
        ...prev,
        [statType]: metricMap
      };
    });
  };

  const handleSubmit = () => {
    console.log('All Global Lines Payload:', lines);

    if (onSaveLines) {
      onSaveLines(lines);
    }

    const totalEntries = Object.values(lines).reduce(
      (acc, obj) => acc + Object.keys(obj || {}).length,
      0
    );
console.log(totalEntries)
  };

  const isActualView = teamData.data[0].length > 5;

  const baseMapping = {
    points: { 
      indices: isActualView ? [0, 4, 3] : [0, 3], 
      headers: isActualView ? ["Pts Pred", "Act", "Player"] : ["Pts Pred", "Player"] 
    },
    assists: { 
      indices: isActualView ? [1, 5, 3] : [1, 3], 
      headers: isActualView ? ["Ast Pred", "Act", "Player"] : ["Ast Pred", "Player"] 
    },
    rebounds: { 
      indices: isActualView ? [2, 6, 3] : [2, 3], 
      headers: isActualView ? ["Reb Pred", "Act", "Player"] : ["Reb Pred", "Player"] 
    }
  };

  const current = baseMapping[statType];
  const headers = showLine ? [...current.headers, "Line"] : current.headers;
  const Container = isActualView ? ActContainer : ArticleContainer;

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', paddingBottom: '8px' }}>
        <LineToggleBtn $active={showLine} onClick={() => setShowLine(!showLine)}>
          {showLine ? 'Hide Line' : 'Line'}
        </LineToggleBtn>
      </div>

      <Container $showLine={showLine}>
        {headers.map((h, i) => (
          <TeamSquare key={`h-${i}`} style={{ background: '#f1f5f9', fontWeight: 'bold' }}>
            {h}
          </TeamSquare>
        ))}

        {teamData.data.map((playerRow, rIdx) => {
          const playerName = playerRow[3];
          const playerEntry = currentMetricLines[playerName];

          return (
            <React.Fragment key={`row-${rIdx}`}>
              {current.indices.map((cIdx) => (
                <TeamSquare 
                  key={`${rIdx}-${cIdx}`} 
                  onClick={() => handleSelectPlayer(playerRow[cIdx])}
                >
                  {playerRow[cIdx]}
                </TeamSquare>
              ))}

              {showLine && (
                <TeamSquare key={`line-${rIdx}`} style={{ padding: '2px' }}>
                  <LineInput
                    type="number"
                    step="0.5"
                    placeholder="0.0"
                    value={playerEntry?.line ?? ''}
                    onChange={(e) => handleLineChange(playerName, e.target.value)}
                  />
                </TeamSquare>
              )}
            </React.Fragment>
          );
        })}
      </Container>

      {showLine && (
        <SubmitBtn onClick={handleSubmit}>
          Submit All Lines
        </SubmitBtn>
      )}
    </div>
  );
}
// const PlayerPage = ({ player, onBack, predData, view, setPredData, todayPred,setTodayPred}) => {
// const [windowSize, setWindowSize] = useState(10);
// const [startIndex, setStartIndex] = useState(0);
// const [endIndex, setEndIndex] = useState(0);
// const GEMS = ['rock', 'ruby', 'jade'];
// const [gem, setGem] = useState('rock');



// const [isUpdating, setIsUpdating] = useState(false);
// const GEM_COLORS = {
//     rock: {
//       border: 'rgb(79, 70, 229)',      // Indigo
//       bg: 'rgba(79, 70, 229, 0.5)',
//     },
//     ruby: {
//       border: 'rgb(225, 29, 72)',      // Crimson/Red
//       bg: 'rgba(225, 29, 72, 0.5)',
//     },
//     jade: {
//       border: 'rgb(16, 185, 129)',     // Emerald Green
//       bg: 'rgba(16, 185, 129, 0.5)',
//     },
//     opal: {
//       border: 'rgb(147, 51, 234)',     // Opal Purple/Cyan accent
//       bg: 'rgba(147, 51, 234, 0.5)',
//     },
//   };

//  async function target_pred(player, target, gem){

//     axios({
//       method: 'post',
//         url: `https://82jsvqje43.execute-api.us-east-2.amazonaws.com/wnba_dev/nba`,
    
//       withCredentials: false,
//       data: {
//       player:player,
//         path:target, 
//         gem:gem
//       },
//     }).then(function (response) {
//       let res = response.data
//       let numbers_res = res.match(/[\d.]+/g);
//       let numbers_list = numbers_res.map(Number);
//       console.log('the lion',numbers_list) 
       
//       const val = numbers_list[0];
//       setTodayPred(val); // Update state directly inside callback
//       return val;

//     })
//     .catch(function (error) {
//     });

//  }
// const playerPred = async (selected, activeGem) => {
//   const now = new Date();

// const month = String(now.getMonth() + 1).padStart(2, '0'); // getMonth() is 0-indexed
// const day = String(now.getDate()).padStart(2, '0')
// console.log('ran code')
//   return axios({
//     method: 'post',
//     url: `https://sx7vpiy3ij.execute-api.us-east-2.amazonaws.com/admin_dev/team-pull`,
//     withCredentials: false,
//     data: {
//       option: 'player-pred',
//       player: selected,
//       day: day, 
//       month:month,
//       gem:activeGem
//     },
//   })
//     .then((res) => {
//       console.log('getting result')
//       console.log('gem result', res.data);

//       console.log(res.data.data)
//       return res.data.data;
//     })
//     .catch((err) => {
//       console.error(err);
//       throw err;
//     });
// };

// const cycleGem = async () => {
//     // Start loading transition
//     setIsUpdating(true);

//     const currentIndex = GEMS.indexOf(gem);
//     const nextGem = GEMS[(currentIndex + 1) % GEMS.length];

//     setGem(nextGem);

//     try {
//       // Execute both requests concurrently
//       const [newData] = await Promise.all([
//         playerPred(player, nextGem),
//         target_pred(player, view, nextGem)
//       ]);

//       setPredData(newData);
//     } catch (error) {
//       console.error("Error updating prediction:", error);
//     } finally {
//       // Stop loading transition
//       setIsUpdating(false);
//     }
//   };
// const playerChartData = useMemo(() => {
// // Correctly extract array using the active view key ('points', 'assists', or 'rebounds')
//     const rawList = predData && predData[view] ? predData[view] : [];

//     if (!Array.isArray(rawList) || rawList.length === 0) return [];

//     return rawList
//       .filter(row => row[0] !== '0')
//       .map((row, i) => ({
//         date: row[0],
//         pred: Number(row[1]),
//         actual: Number(row[2]),
//         label: row[0],
//         _sortKey: i,
//       }))
//       .sort((a, b) => new Date(a.date) - new Date(b.date) || a._sortKey - b._sortKey);
//   }, [predData, view]);

// useEffect(() => {
//   if (playerChartData.length === 0) return;
//   const end = playerChartData.length - 1;
//   const start = Math.max(0, end - windowSize + 1);
//   setStartIndex(start);
//   setEndIndex(end);
// }, [playerChartData.length, windowSize]);

//   console.log('whale', predData)

//   const handleBack = () => {
//   setStartIndex(prev => Math.max(0, prev - 1));
//   setEndIndex(prev => Math.max(windowSize - 1, prev - 1));
// };

// const handleForward = () => {
//   setStartIndex(prev => Math.min(playerChartData.length - windowSize, prev + 1));
//   setEndIndex(prev => Math.min(playerChartData.length - 1, prev + 1));
// };

// const isBackDisabled = startIndex === 0;
// const isForwardDisabled = endIndex >= playerChartData.length - 1;

// const cycleWindowSize = () => {
//   setWindowSize(prev => {
//     if (prev >= 20) return 5;
//     return prev + 5;
//   });
// };

// const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     layout: {
//       padding: { left: 0, right: 0, top: 0, bottom: 0 },
//     },
//     scales: {
//       x: {
//         ticks: { autoSkip: false },
//       },
//     },
//   };

//   const chartDataForPlayer = useMemo(() => {
//     if (playerChartData.length === 0) {
//       return { labels: [], datasets: [] };
//     }

//     const visible = playerChartData.slice(startIndex, endIndex + 1);
//     const currentColor = GEM_COLORS[gem] || GEM_COLORS.rock;

//     return {
//       labels: visible.map((d) => d.date),
//       datasets: [
//         {
//           label: `Predicted (${gem.toUpperCase()})`,
//           data: visible.map((d) => d.pred),
//           borderColor: currentColor.border,
//           backgroundColor: currentColor.bg,
//           fill: false,
//           tension: 0.2,
//         },
//         {
//           label: 'Actual',
//           data: visible.map((d) => d.actual),
//           borderColor: 'rgb(34, 197, 94)', // Green for actual values
//           backgroundColor: 'rgba(34, 197, 94, 0.5)',
//           fill: false,
//           tension: 0.2,
//         },
//       ],
//     };
//   }, [playerChartData, startIndex, endIndex, gem]);

const ChartWrapper = styled.div`
  position: relative;
  width: 80vw;
  height: 60vh;   /* or whatever fills your screen the way you want */
`;




// return(

//   <div>
//     <BackBtn onClick={onBack}>← Back</BackBtn>
    
//     <h2>{player}</h2>
   
//     <div>

//     <StatWrapper>
//       <h3 style={{ margin: 0 }}>Today's Pred:</h3>
//       {isUpdating || todayPred === null ? (
//         <Spinner />
//       ) : (
//         <h4 style={{ margin: 0 }}>{todayPred}</h4>
//       )}
//     </StatWrapper>

//       <GemToggleBtn onClick={cycleGem} disabled={isUpdating}>
//         {isUpdating ? 'Updating...' : gem}
//       </GemToggleBtn>
//   <button onClick={handleBack} disabled={isBackDisabled}>← Back</button>
//   <button onClick={handleForward} disabled={isForwardDisabled}>Forward →</button>
//   <button onClick={cycleWindowSize}>Show last {windowSize}</button>
// </div>
// <ChartWrapper>
//     <Line data={chartDataForPlayer} options={options} width="80vw" 
//   height="50vh"/>

// </ChartWrapper>

//   </div>
// )
// }



const PlayerPage = ({ player, onBack, view, team }) => {
  const GEMS = [ 'amethyst3','emerald3','amethyst1','emerald1']

  const [gem, setGem] = useState('amethyst3');
  const [windowSize, setWindowSize] = useState(10);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(0);

  // Store pre-fetched data keyed by gem name
  const [allPredData, setAllPredData] = useState({});
  const [allTodayPreds, setAllTodayPreds] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [allFeatures, setAllFeatures] = useState({}); // New state for feature metrics

const GEM_COLORS = {
  rock: { 
    border: 'rgb(107, 114, 128)', // Slate / Slate Gray
    bg: 'rgba(107, 114, 128, 0.5)' 
  },
  ruby: { 
    border: 'rgb(225, 29, 72)',   // Crimson Red
    bg: 'rgba(225, 29, 72, 0.5)' 
  },
  diamond: { 
    border: 'rgb(56, 189, 248)',  // Icy Blue Sheen
    bg: 'rgba(56, 189, 248, 0.5)' 
  },
  quartz: { 
    border: 'rgb(236, 72, 153)',  // Rose Quartz Pink
    bg: 'rgba(236, 72, 153, 0.5)' 
  },
  beryl: { 
    border: 'rgb(16, 185, 129)',  // Emerald Green
    bg: 'rgba(16, 185, 129, 0.5)' 
  },
  mica: { 
    border: 'rgb(245, 158, 11)',  // Amber / Golden Sheen
    bg: 'rgba(245, 158, 11, 0.5)' 
  }
};
  // 1. Fetch single prediction endpoint for a given gem

  // 2. Fetch single today pred value for a given gem
  const fetchGemTodayPred = async (selectedPlayer, targetView, activeGem) => {
    console.log('today preds',activeGem )
    const res = await axios({
      method: 'post',
      url: `https://82jsvqje43.execute-api.us-east-2.amazonaws.com/wnba_dev/nba`,
      withCredentials: false,
      data: {
        player: selectedPlayer,
        path: targetView,
        gem: activeGem,
      },
    });
    const numbers_res = res.data.match(/[\d.]+/g);
 
    return numbers_res ? Number(numbers_res[0]) : null;
  };

    const fetchGemFeatures= async ( targetView, activeGem) => {
    const res = await axios({
      method: 'post',
      url: `https://sx7vpiy3ij.execute-api.us-east-2.amazonaws.com/admin_dev/team-pull`,
      withCredentials: false,
      data: {
        option: 'features',
        target: targetView,
        gem: activeGem,
      },
    });

    const numbers_res = res.data
    console.log('fatcat', numbers_res)
    return numbers_res 
  };
  // 3. Parallel fetch ALL gems at once on mount
// --- Replace fetchGemChartData and useEffect in PlayerPage ---

const fetchGemChartData = async (selectedPlayer, activeGem, teamStr) => {
  try {
    if (!teamStr || !teamStr.includes('_')) return null;
    const parts = teamStr.split('_');
    if (parts.length < 3) return null;

    const month = parts[1];
    const day = parts[2].slice(0, 2);

    const res = await axios({
      method: 'post',
      url: `https://sx7vpiy3ij.execute-api.us-east-2.amazonaws.com/admin_dev/team-pull`,
      withCredentials: false,
      data: {
        option: 'player-pred',
        player: selectedPlayer,
        day,
        month,
        gem: activeGem,
      },
    });


    return res.data?.data || null;
  } catch (err) {
    console.error(`Chart data error [${activeGem}]:`, err);
    return null;
  }
};

useEffect(() => {
  let isSubscribed = true;

  const fetchAllGems = async () => {
    setIsLoading(true);

    // Create array of promises for all gems
    const gemPromises = GEMS.map(async (g) => {
      const [todayRes, featRes, chartRes] = await Promise.allSettled([
        fetchGemTodayPred(player, view, g),
        fetchGemFeatures(view, g),
        fetchGemChartData(player, g, team),
      ]);

      if (!isSubscribed) return;

      // Safely update state for each gem as it resolves
      if (todayRes.status === 'fulfilled') {
        setAllTodayPreds((prev) => ({ ...prev, [g]: todayRes.value }));
      }
      if (featRes.status === 'fulfilled') {
        const data = featRes.value?.data || featRes.value || [];
        const formatted = Array.isArray(data) ? data : Object.entries(data);
        setAllFeatures((prev) => ({ ...prev, [g]: formatted }));
      }
      if (chartRes.status === 'fulfilled') {
        setAllPredData((prev) => ({ ...prev, [g]: chartRes.value }));
      }
    });

    // Wait until ALL gems have either finished or failed
    await Promise.allSettled(gemPromises);

    if (isSubscribed) {
      setIsLoading(false);
    }
  };

  fetchAllGems();

  return () => {
    isSubscribed = false;
  };
}, [player, view, team]);

  // Instant switch — simply changes active key in local state
  const cycleGem = () => {
    const currentIndex = GEMS.indexOf(gem);
    const nextGem = GEMS[(currentIndex + 1) % GEMS.length];
    setGem(nextGem);
  };

  // Derive current chart data from active gem key
  const playerChartData = useMemo(() => {
  const activeData = allPredData[gem];
  const rawList = activeData && activeData[view] ? activeData[view] : [];

  if (!Array.isArray(rawList) || rawList.length === 0) return [];

  // Helper to safely parse numbers whether row[1] is a number, clean string, 
  // bracketed string ("[8.33]"), or nested array ([8.33])
  const parseValue = (val) => {
    if (val === null || val === undefined) return null;
    if (Array.isArray(val)) return Number(val[0]);
    if (typeof val === 'string') {
      const cleaned = val.replace(/[\[\]\s]/g, '');
      return cleaned === '' ? null : Number(cleaned);
    }
    return Number(val);
  };

  return rawList
    .filter((row) => row[0] !== '0')
    .map((row, i) => ({
      date: row[0],
      pred: parseValue(row[1]),
      actual: parseValue(row[2]),
      label: row[0],
      _sortKey: i,
    }))
    .sort((a, b) => new Date(a.date) - new Date(b.date) || a._sortKey - b._sortKey);
}, [allPredData, gem, view]);

  useEffect(() => {
    if (playerChartData.length === 0) return;
    const end = playerChartData.length - 1;
    const start = Math.max(0, end - windowSize + 1);
    setStartIndex(start);
    setEndIndex(end);
  }, [playerChartData.length, windowSize]);

  const handleBack = () => {
    setStartIndex((prev) => Math.max(0, prev - 1));
    setEndIndex((prev) => Math.max(windowSize - 1, prev - 1));
  };

  const handleForward = () => {
    setStartIndex((prev) => Math.min(playerChartData.length - windowSize, prev + 1));
    setEndIndex((prev) => Math.min(playerChartData.length - 1, prev + 1));
  };

  const isBackDisabled = startIndex === 0;
  const isForwardDisabled = endIndex >= playerChartData.length - 1;

  const cycleWindowSize = () => {
    setWindowSize((prev) => (prev >= 20 ? 5 : prev + 5));
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: { left: 0, right: 0, top: 0, bottom: 0 } },
    scales: { x: { ticks: { autoSkip: false } } },
  };

  const chartDataForPlayer = useMemo(() => {
    if (playerChartData.length === 0) return { labels: [], datasets: [] };

    const visible = playerChartData.slice(startIndex, endIndex + 1);
    const currentColor = GEM_COLORS[gem] || GEM_COLORS.rock;

    return {
      labels: visible.map((d) => d.date),
      datasets: [
        {
          label: `Predicted (${gem.toUpperCase()})`,
          data: visible.map((d) => d.pred),
          borderColor: currentColor.border,
          backgroundColor: currentColor.bg,
          fill: false,
          tension: 0.2,
        },
        {
          label: 'Actual',
          data: visible.map((d) => d.actual),
          borderColor: 'rgb(34, 197, 94)',
          backgroundColor: 'rgba(34, 197, 94, 0.5)',
          fill: false,
          tension: 0.2,
        },
      ],
    };
  }, [playerChartData, startIndex, endIndex, gem]);

  const currentTodayPred = allTodayPreds[gem];
  const currentFeatures = allFeatures[gem] || [];
  const EXCLUDED_METRICS = ['y_train_range', 'y_train_std', 'y_test_range', 'y_true'];
  return (
    <div>

    

      <DisplayDiv>
<h2 style={{ marginTop: '10px' }}>{player}</h2>   
   <BackBtn onClick={onBack}>← Back</BackBtn>
        <StatWrapper>
          <h3 style={{ margin: 0 }}>Today's Pred:</h3>
          {isLoading ? (
            <Spinner />
          ) : (
            <h4 style={{ margin: 0 }}>{currentTodayPred}</h4>
          )}
        </StatWrapper>

        <GemToggleBtn onClick={cycleGem} disabled={isLoading}>
          {isLoading ? 'Loading all gems...' : gem}
        </GemToggleBtn>

        <button onClick={handleBack} disabled={isBackDisabled || isLoading}>
          ← Back
        </button>
         <button onClick={handleForward} disabled={isForwardDisabled || isLoading}>
          Forward →
        </button>
        <button onClick={cycleWindowSize} disabled={isLoading}>
          Show last {windowSize}
        </button>
      </DisplayDiv>

{!isLoading && currentFeatures.length > 0 && (
<FeatureContainer>
  {currentFeatures
    .filter(([metricKey]) => !EXCLUDED_METRICS.includes(metricKey))
    .map(([metricKey, val]) => (
      <FeatureItem key={metricKey}>
        <FeatureLabel>{metricKey}</FeatureLabel>
        <FeatureValue>{shortenValue(val)}</FeatureValue>
      </FeatureItem>
    ))}
</FeatureContainer>
      )}
      <ChartWrapper style={{ opacity: isLoading ? 0.4 : 1, transition: 'opacity 0.2s ease' }}>
        <Line data={chartDataForPlayer} options={options} width="80vw" height="50vh" />
      </ChartWrapper>
    </div>
  );
};

const FullArticle = ({ onClose }) => {
  const [article, setOneArticle] = useState(null);
  const [view, setView] = useState('menu'); // 'menu' | 'points' | 'assists' | 'rebounds'
  const { teamData, id, setId } = useContext(PredContext);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [playerPredData, setPlayerPredData] = useState(null);
  const [todayPred, setTodayPred] = useState(12);
  const [team, setTeam] = useState('');
  const [selectedNewTeamId, setSelectedNewTeamId] = useState('');

  // --- 1. EXTRACT CURRENT TEAM'S DATE KEY (e.g., "05_12") ---
  const currentTeamDateKey = useMemo(() => {
    if (!team) return null;
    const match = String(team).match(/(\d{2}_\d{2})(?:\.csv)?$/);
    return match ? match[1] : null;
  }, [team]);

  // --- 2. DYNAMICALLY FILTER TEAMS FOR THE SAME DAY ONLY ---
  const sameDayTeams = useMemo(() => {
    if (!currentTeamDateKey) return [];

    return teamData
      .filter((t) => {
        const teamDateMatch = String(t.team).match(/(\d{2}_\d{2})(?:\.csv)?$/);
        const teamDateKey = teamDateMatch ? teamDateMatch[1] : null;
        // Include teams matching the exact same date key
        return teamDateKey === currentTeamDateKey;
      })
      .map((t) => ({ id: t.id, name: t.team }));
  }, [teamData, currentTeamDateKey]);

  // --- 3. SWITCH TEAM ACTION ---
  const handleSwitchTeam = (targetId) => {
    const numericId = Number(targetId);
    const targetTeamObj = teamData.find((art) => art.id === numericId);
    if (targetTeamObj) {
      setId(numericId);
      setTeam(targetTeamObj.team);
      const cleaned = {
        ...targetTeamObj,
        data: targetTeamObj.data.map((player) =>
          player.map((cell) => shortenValue(cell))
        ),
      };
      setOneArticle(cleaned);
      setSelectedPlayer(null); // Reset player view when switching teams
    }
  };

  const playerPred = async (selected) => {
    let day = team.split('_')[2].slice(0, 2);
    let month = team.split('_')[1];
    return axios({
      method: 'post',
      url: `https://sx7vpiy3ij.execute-api.us-east-2.amazonaws.com/admin_dev/team-pull`,
      withCredentials: false,
      data: {
        option: 'player-pred',
        player: selected,
        day: day,
        month: month,
      },
    })
      .then((res) => res.data.data)
      .catch((err) => {
        console.error(err);
        throw err;
      });
  };

  const handleSelectPlayer = async (playerRow) => {
    setSelectedPlayer(playerRow);
    setPlayerPredData(null);
    setTodayPred(null);
    const result = await playerPred(playerRow);
    setPlayerPredData(result);
  };

  useEffect(() => {
    const found = teamData.find((art) => art.id === id);
    if (found) {
      const cleaned = {
        ...found,
        data: found.data.map((player) =>
          player.map((cell) => shortenValue(cell))
        ),
      };
      setOneArticle(cleaned);
      setTeam(found.team);
    }
  }, [teamData, id]);

  const props = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    config: { duration: 200 },
  });

  if (!article) return null;

  return (
    <FullScreenOverlay style={props}>
      {/* Show team selector ONLY when a individual player is NOT selected */}
      {view !== 'menu' && !selectedPlayer && (
        <div
          style={{
            width: '100%',
            maxWidth: '600px',
            padding: '10px 16px',
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
            background: '#f1f5f9',
            borderRadius: '8px',
            marginBottom: '10px',
          }}
        >
          <select
            value={selectedNewTeamId || id}
            onChange={(e) => setSelectedNewTeamId(e.target.value)}
            style={{
              flex: 1,
              padding: '8px',
              borderRadius: '6px',
              border: '1px solid #cbd5e1',
              fontSize: '0.85rem',
              fontWeight: '600',
            }}
          >
            {sameDayTeams.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
          </select>

          <button
            onClick={() => handleSwitchTeam(selectedNewTeamId)}
            disabled={!selectedNewTeamId || Number(selectedNewTeamId) === id}
            style={{
              backgroundColor: '#2563eb',
              color: 'white',
              border: 'none',
              padding: '8px 12px',
              borderRadius: '6px',
              fontSize: '0.85rem',
              fontWeight: '700',
              cursor: 'pointer',
              opacity:
                !selectedNewTeamId || Number(selectedNewTeamId) === id
                  ? 0.5
                  : 1,
            }}
          >
            Load Team
          </button>
        </div>
      )}

      {view === 'menu' ? (
        <MenuContainer>
          <h2 style={{ textAlign: 'center', marginBottom: '10px' }}>
            {article.team}
          </h2>
          <StatButton
            onClick={() => {
              setView('points');
              setTeam(article.team);
            }}
          >
            Points
          </StatButton>
          <StatButton
            onClick={() => {
              setView('assists');
              setTeam(article.team);
            }}
          >
            Assists
          </StatButton>
          <StatButton
            onClick={() => {
              setView('rebounds');
              setTeam(article.team);
            }}
          >
            Rebounds
          </StatButton>
          <CloseButton onClick={onClose}>Close</CloseButton>
        </MenuContainer>
      ) : selectedPlayer ? (
        <PlayerPage
          team={team}
          player={selectedPlayer}
          view={view}
          onBack={() => setSelectedPlayer(null)}
        />
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateRows: '10% 90%',
            width: '100%',
            maxWidth: '600px',
            height: '100vh',
            overflow: 'hidden',
          }}
        >
          <HeaderContainer>
            <BackBtn onClick={() => setView('menu')}>← Back</BackBtn>
            <span style={{ fontWeight: 'bold', color: 'black' }}>
              {view.toUpperCase()}
            </span>
            <div style={{ width: '60px' }}></div>
          </HeaderContainer>
          <Article
            teamData={article}
            statType={view}
            handleSelectPlayer={handleSelectPlayer}
          />
        </div>
      )}
    </FullScreenOverlay>
  );
};
function TeamData() {
  const [showFullArticle, setShowFullArticle] = useState(false);
  const [selectedDateGroup, setSelectedDateGroup] = useState(null);
  const { email } = useContext(PriceContext);
  const { teamData, setTeamData, setId } = useContext(PredContext);

  const predCheck = async () => {
    console.log('dragons')
    try {
      const response = await axios({
        method: 'post',
        url: `https://dhqs56xckk.execute-api.us-east-2.amazonaws.com/pred_dev/load`,
        data: { email: email, path: 'team-data' },
      });
      const teamDataOrganized = orderTeam(response.data.data);
      setTeamData(teamDataOrganized);
    } catch (error) {
      console.error('Error fetching team data:', error.message);
    }
  };

  useEffect(() => { predCheck(); }, []);

  const dateGroups = useMemo(() => groupTeamsByDate(teamData), [teamData]);

  return (
    <GameAnalysisContainer>
      {showFullArticle && <FullArticle onClose={() => setShowFullArticle(false)} />}

      {!selectedDateGroup ? (
        <>
          <SectionTitle>Team Predictions</SectionTitle>
          {dateGroups.map((group) => (
            <SubscriptionItem key={group.key}>
              <IconContainer>
                <svg width="24" height="24" fill="currentColor" viewBox="0 0 256 256">
                  <path d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,112h-8a32,32,0,0,1,0-64h8ZM32,96h8a32,32,0,0,1,0,64H32Zm0,80h8a48,48,0,0,0,0-96H32V64h88V192H32Zm192,16H136V64h88V80h-8a48,48,0,0,0,0,96h8v16Z"></path>
                </svg>
              </IconContainer>
              <GameAnalysisTitle onClick={() => setSelectedDateGroup(group)}>
                {group.label}
              </GameAnalysisTitle>
            </SubscriptionItem>
          ))}
        </>
      ) : (
        <>
          <BackBtn onClick={() => setSelectedDateGroup(null)}>← Back</BackBtn>
          <SectionTitle>{selectedDateGroup.label}</SectionTitle>
          {selectedDateGroup.teams.map((team) => (
            <SubscriptionItem key={team.id}>
              <IconContainer>
                <svg width="24" height="24" fill="currentColor" viewBox="0 0 256 256">
                  <path d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,112h-8a32,32,0,0,1,0-64h8ZM32,96h8a32,32,0,0,1,0,64H32Zm0,80h8a48,48,0,0,0,0-96H32V64h88V192H32Zm192,16H136V64h88V80h-8a48,48,0,0,0,0,96h8v16Z"></path>
                </svg>
              </IconContainer>
              <GameAnalysisTitle onClick={() => { setId(team.id); setShowFullArticle(true); }}>
                {team.team}
              </GameAnalysisTitle>
            </SubscriptionItem>
          ))}
        </>
      )}
    </GameAnalysisContainer>
  );
}

export default TeamData;